import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import H2 from '@base/H2/H2';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import { isOnlyRecordedClassesPresentSelector } from '@selectors/courses';
import StartsOn from '@cont/Course/StartsOn';
import SessionCount from '@cont/Course/CourseHeader/SessionCount';
import Languages from '@cont/Course/LanguageAboutDrawer';
import { Spacings } from '@styles/index';
import DppCount from '@cont/Course/CourseHeader/DppCount';
import EducatorDetailedCard from '../EducatorDetailedCard/EducatorDetailedCard';

const About = styled(H2)`
  grid-column: span 12;
  color: var(--color-text-primary);
`;

const Description = styled(P1)`
  grid-column: span 10;
  margin-top: ${Spacings.SPACING_6B};
  color: var(--color-text-primary);
`;

const Educator = styled(H4)`
  margin-top: ${Spacings.SPACING_16B};
  grid-column: span 12;
  margin-bottom: ${Spacings.SPACING_3B};
  color: var(--color-text-primary);
  @media (max-width: 47.95em) {
    margin-top: 40px;
    margin-bottom: 0;
  }
`;

const linkStyle = `
  margin-top: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_3B};
`;

const AboutDrawer = ({ data, isTestSeries, infoString, isHybridCourse }) => {
  const isOnlyRecordedClassesPresent = useSelector(
    isOnlyRecordedClassesPresentSelector(data.uid)
  );
  const renderEducatorInfo = () => {
    const showEducatorsInfo = Array.isArray(data?.authors) && !isHybridCourse;
    if (showEducatorsInfo) {
      return (
        <>
          <Educator>Educator</Educator>
          {data.authors.map((educator) => (
            <EducatorDetailedCard
              key={educator.uid}
              gridColumn="span 10"
              educator={educator}
              linkStyle={linkStyle}
              showBadge
            />
          ))}
        </>
      );
    }
    return null;
  };

  const renderDPPAndEducatorInfo = () => {
    if (isTestSeries) {
      return null;
    }

    return (
      <>
        {!isOnlyRecordedClassesPresent && <DppCount />}
        {renderEducatorInfo()}
      </>
    );
  };

  return (
    <>
      <About>About</About>
      <Description>{data?.description}</Description>
      {!isOnlyRecordedClassesPresent && (
        <StartsOn
          startsAt={data?.startsAt}
          endsAt={data?.endsAt}
          fromAboutDrawer
        />
      )}
      <Languages
        voiceLanguages={data?.voiceLanguages}
        contentSlideLanguages={data?.contentSlideLanguages}
        height={Spacings.SPACING_12B}
        width={Spacings.SPACING_12B}
      />
      <SessionCount
        lessonCount={data?.liveClassCount}
        quizCount={data?.quizCount}
        isTestSeries={isTestSeries}
        infoString={infoString}
      />

      {renderDPPAndEducatorInfo()}
    </>
  );
};

export default AboutDrawer;

AboutDrawer.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  isTestSeries: PropTypes.bool,
  infoString: PropTypes.string,
  isHybridCourse: PropTypes.bool
};

AboutDrawer.defaultProps = {
  data: {},
  isTestSeries: false,
  infoString: null,
  isHybridCourse: false
};
